<div class="relative flex flex-wrap items-center gap-1.5 min-h-[36px]">

  <!-- Selected tag chips -->
  @for (tag of selectedTags(); track tag) {
    <span class="inline-flex items-center gap-1 pl-2.5 pr-1.5 py-0.5 rounded-full text-xs font-medium bg-primary-50 text-primary-700 border border-primary-200">
      {{ tag }}
      <button type="button" (click)="removeTag(tag)"
        class="w-4 h-4 rounded-full flex items-center justify-center hover:bg-primary-200 transition-colors text-primary-400 hover:text-primary-800">
        <svg class="w-2.5 h-2.5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </span>
  }

  <!-- Add tag button -->
  @if (!showInput()) {
    <button type="button" (click)="openInput(); $event.stopPropagation()"
      class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium text-stone-400 border border-dashed border-stone-300 hover:border-primary-400 hover:text-primary-600 transition-colors">
      <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
      </svg>
      Ajouter un tag
    </button>
  }

  <!-- Input + dropdown -->
  @if (showInput()) {
    <div class="relative w-full mt-1" (click)="$event.stopPropagation()">
      <div class="flex gap-1.5">
        <input
          type="text"
          [ngModel]="inputText()"
          (ngModelChange)="onInputChange($event)"
          placeholder="Rechercher ou créer un tag…"
          class="fiche-input flex-1"
          autocomplete="off"
          autofocus
        />
        <button
          type="button"
          (click)="onAdd()"
          [disabled]="!inputText().trim() || isCreating()"
          class="inline-flex items-center gap-1 text-[11px] font-semibold px-3 py-1.5 rounded-lg bg-primary-600 text-white hover:bg-primary-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors whitespace-nowrap flex-shrink-0">
          @if (isCreating()) {
            <div class="w-3 h-3 border border-white border-t-transparent rounded-full animate-spin"></div>
          } @else {
            <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
            </svg>
          }
          {{ hasExactMatch() ? 'Sélectionner' : 'Créer' }}
        </button>
      </div>

      @if (errorMsg()) {
        <p class="text-[11px] text-red-500 mt-1 ml-1">{{ errorMsg() }}</p>
      }

      @if (filteredTags().length > 0) {
        <div class="absolute top-full left-0 right-0 z-30 bg-white border border-stone-200 rounded-xl shadow-lg mt-1 max-h-48 overflow-y-auto">
          @for (tag of filteredTags(); track tag) {
            <button
              type="button"
              (click)="selectTag(tag)"
              class="w-full text-left px-3 py-2 text-sm text-stone-700 hover:bg-stone-50 transition-colors first:rounded-t-xl last:rounded-b-xl">
              {{ tag }}
            </button>
          }
        </div>
      }

      @if (inputText().trim() && filteredTags().length === 0 && !hasExactMatch()) {
        <div class="absolute top-full left-0 right-0 z-30 bg-white border border-stone-200 rounded-xl shadow-lg mt-1 px-3 py-2 text-xs text-stone-400">
          Nouveau tag — cliquez <span class="font-semibold text-primary-600">Créer</span>
        </div>
      }
    </div>
  }

</div>
